import { BaseMany, BaseQueryMany } from './Base';
import { DateTimeRange } from './Range';

export enum Permission {
  ShipmentExecution = 'ShipmentExecution',
  TourPlanner = 'TourPlanner',
  OrderManagement = 'OrderManagement',
}

export enum UserLanguages {
  DE = 'DE',
  GB = 'GB',
  PL = 'PL',
}

export class User {
  userId: string; // QUESTION: maybe change to id
  email: string;
  tenantId: string;
  userType: UserType;
  // roles: Role[]; // NOTE: removed with multi-auth
  permissions?: Permission[];
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum UserType {
  TEAM_ADMIN = 'TEAM_ADMIN',
  USER = 'USER',
  BACK_OFFICE = 'BACK_OFFICE',
}

export enum UserEmailVerified {
  VERIFIED = 'VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED',
}

export type UserInput = {
  firstName: string;
  lastName: string;
  email: string;
  language: UserLanguages;
  userType: UserType;
  status: UserStatus;
};

export type UserOutput = UserInput & {
  id: string;
  username: string;
  name: string;
  createdDate: Date;
  invitedOn?: Date;
};

export type BackOfficeUserInput = UserInput & {
  password: string;
  tenantId: string;
  groups: string[];
  emailVerified: UserEmailVerified;
};

export class QueryUsers extends BaseQueryMany<UserFilters>() {}

export type Users = BaseMany<UserOutput>;

export interface UserFilters {
  email?: string;
  emailVerified?: UserEmailVerified;
  firstName?: string;
  lastName?: string;
  status?: UserStatus;
  userId?: string;
  userType?: UserType;
  invitedOnRange?: DateTimeRange;
}

export interface QueryUsersOutput {
  users: Users;
}

export interface UsersQueryVariables {
  query: QueryUsers;
}

export type UserRegistrationInput = Omit<
  UserInput,
  'status' | 'email' | 'userType'
> & {
  newUserId: string;
};
